import React from 'react';

const RealEstateCard = (props) => {
  const { bseq, realestate_name, content_photo_url, content_title, content_url, create_at } = props.data;

  const isNew = checkNewStatus(create_at);

  function checkNewStatus(createAt) {
    const createAtDate = new Date(createAt);
    const currentDate = new Date();
    const timeDifference = currentDate - createAtDate;
    const oneWeekInMillis = 7 * 24 * 60 * 60 * 1000;
    const withinOneWeek = timeDifference <= oneWeekInMillis;
    return withinOneWeek;
  }

  return (
    <div className='container-fluid'>
      <div
        className={
          props.idx === 0 &&
          props.length === 2 &&
          'my-3 border border-top-0 border-left-0 border-right-0 border-bottom-1'
        }
      >
        <a className='d-flex flex-row' href={content_url}>
          <div className='col-10'>
            <div className='row'>
              <small className='text-gray-600'>{realestate_name}</small>
            </div>
            <div className='row my-2'>
              <p className='text-gray-900'>{`${
                content_title.length > 23 ? `${content_title.substring(0, 23)}...` : content_title
              }`}</p>
              {isNew ? (
                <p>
                  <small className='ml-1 font-weight-bold text-danger'>N</small>
                </p>
              ) : null}
            </div>
          </div>
          {content_photo_url && (
            <div className='col-2'>
              <img
                className='rounded'
                src={content_photo_url}
                alt={`${bseq}-${realestate_name} 사진`}
                width={50}
                height={50}
              />
            </div>
          )}
        </a>
      </div>
    </div>
  );
};

export default RealEstateCard;
